// extracted by mini-css-extract-plugin
module.exports = {"category":"Cards_category__5p_d_","text":"Cards_text__W29E7","cards":"Cards_cards__2AMfI","card":"Cards_card__1098T","plus":"Cards_plus__16XEq"};